import * as React from 'react';

function SvgNumBookings(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 42 46" {...props}>
      <path d="M14.624 4.6h10.7c1.247 0 2.276-1.028 2.276-2.3S26.543 0 25.243 0h-10.62c-1.3 0-2.356 1.028-2.356 2.3s1.056 2.3 2.357 2.3z" />
      <path d="M9.06 3.067c0 2.724.601 5.079 3.644 5.19l.227.004h15.538c3.19 0 3.841-1.738 3.87-4.956l.001-.238h5.162c2.367 0 3.806 1.296 3.894 3.688l.004.235V43a3 3 0 01-2.824 2.995L38.4 46H3.871C1.477 46 .089 44.755.004 42.342L0 42.105V6.962c0-2.221 1.597-3.795 3.669-3.89l.202-.005zM22.5 34h-14a1.5 1.5 0 000 3h14a1.5 1.5 0 000-3zm10-9h-24a1.5 1.5 0 00-.144 2.993L8.5 28h24a1.5 1.5 0 000-3zm0-9h-24a1.5 1.5 0 00-.144 2.993L8.5 19h24a1.5 1.5 0 000-3z" />
    </svg>
  );
}

export default SvgNumBookings;
